import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { json } from "@remix-run/node";
import {
  Form,
  Link,
  useActionData,
  useNavigation,
  useSubmit,
} from "@remix-run/react";
import { useEffect, useRef, useState } from "react";

export async function action({ request }) {
  // await new Promise((res) => setTimeout(res, 1000));
  const formData = await request.formData();
  const token = formData.get("recaptchaToken");

  const secret = "6LetLnAgAAAAAKjGbMi7rmFusv9Z4Zgvx0gIKfaH";
  const response = await fetch(
    `https://www.google.com/recaptcha/api/siteverify?secret=${secret}&response=${token}`,
    {
      method: "POST",
    }
  );
  const data = await response.json();

  // return an error if the token is invalid or score is too low
  if (!data.success || data.score < 0.5) {
    return json({ success: false, message: "Invalid reCAPTCHA token" });
  }

  // POST date to Getform
  let res = await fetch("https://getform.io/f/wbrknwla", {
    method: "POST",
    body: formData,
    headers: {
      Accept: "application/json",
    },
  });

  return res.json();
}

export const meta = () => {
  return [
    { title: "Contact Us | Shopdeploy" },
    {
      name: "description",
      content:
        "Have any questions about Shopdeploy? Contact the Team to get all your ecommerce questions answered, see how we can help grow your business, do a live walkthrough of the platform, and explore which pricing plan is best for you.",
    },
  ];
};

export default function Contact() {
  const actionData = useActionData();
  const navigation = useNavigation();
  const submit = useSubmit();
  const [height, setHeight] = useState(532); // To store the height

  const state = navigation.formData
    ? "submitting"
    : actionData?.success
    ? "success"
    : actionData?.success === false
    ? "error"
    : "idle";

  const inputRef = useRef(null);
  const successRef = useRef(null);
  const mounted = useRef(false);
  const formRef = useRef(null);

  useEffect(() => {
    // Load reCAPTCHA script
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?render=6LetLnAgAAAAAERzgY_sZrOJSd9cuyiwtmuiUK_7";
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (formRef.current) {
      // Step 3: Access the element's height
      const height = formRef.current.offsetHeight;
      setHeight(height); // Update the state with the height
    }
  }, []); // Empty dependency array means this runs once after initial render

  useEffect(() => {
    if (state === "error") {
      inputRef.current?.focus();
    }

    if (state === "idle" && mounted.current) {
      inputRef.current?.select();
    }

    if (state === "success") {
      successRef.current?.focus();
    }

    mounted.current = true;
  }, [state]);

  return (
    <div>
      <script></script>
      <div className="bg-indigo-800">
        <div className="mx-auto sm:max-w-7xl py-10 md:py-14 px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row gap-5">
          <div className="flex items-center">
            <div>
              <h1 className="text-4xl sm:text-5xl font-extrabold text-white mb-4">
                Contact the Shopdeploy Team
              </h1>
              <div className="ml-6 hidden sm:block">
                <ul className="list-disc text-white text-xl leading-loose">
                  <li>Get all your ecommerce questions answered</li>
                  <li>See how we can help grow your business</li>
                  <li>Do a live walkthrough of the platform</li>
                  <li>Explore which pricing plan is best for you</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="p-5 bg-white rounded-lg max-w-lg w-full ">
            <Form
              replace
              method="post"
              hidden={state === "success"}
              ref={formRef}
              onSubmit={async (e) => {
                /*global grecaptcha*/
                /*eslint no-undef: "error"*/
                e.preventDefault();
                const recaptchaToken = await grecaptcha.execute(
                  "6LetLnAgAAAAAERzgY_sZrOJSd9cuyiwtmuiUK_7",
                  {
                    action: "contact",
                  }
                );
                const formData = new FormData(e.target);
                formData.append("recaptchaToken", recaptchaToken);

                submit(formData, { method: "post" });
              }}
            >
              <fieldset className="space-y-4" disabled={state === "submitting"}>
                <div>
                  <label
                    htmlFor="name"
                    className="block mb-2 text-sm font-medium text-gray-700"
                  >
                    Full name
                  </label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm disabled:bg-slate-50"
                    ref={inputRef}
                    required
                  />
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm disabled:bg-slate-50"
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="business"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Business name
                  </label>
                  <input
                    type="text"
                    name="business"
                    id="business"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm disabled:bg-slate-50"
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="phone"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Phone
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    id="phone"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm disabled:bg-slate-50"
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="subject"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    How can we help?
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    className="mt-2 block w-full disabled:bg-slate-50 rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    required
                    defaultValue={""}
                  >
                    <option value="" disabled></option>
                    <option>I have a question regarding my account</option>
                    <option>I need help choosing or upgrading my plan</option>
                    <option>
                      I have a question about a feature or functionality
                    </option>
                    <option>
                      I need help figuring out how Shopdeploy can best help my
                      business
                    </option>
                    <option>I have a general question</option>
                  </select>
                </div>
                <div>
                  <label
                    htmlFor="message"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Message
                  </label>
                  <textarea
                    name="message"
                    id="message"
                    rows="4"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm disabled:bg-slate-50"
                    required
                  ></textarea>
                </div>
                <div>
                  <button
                    type="submit"
                    className="g-recaptcha inline-flex w-full justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-indigo-600/75"
                  >
                    {state === "submitting" ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </fieldset>

              {state === "error" && (
                <p className="text-red-600 mt-1">
                  {actionData.message
                    ? actionData.message
                    : "An error occurred."}
                </p>
              )}
            </Form>

            <div
              hidden={state !== "success"}
              className="transition ease-in-out delay-150"
            >
              <div
                className={`text-center items-center justify-center flex flex-col space-y-4`}
                style={{ height: `${height}px` }}
              >
                <h2 className="text-2xl" ref={successRef} tabIndex={-1}>
                  Request Submitted
                </h2>
                <p>
                  <CheckCircleIcon className="h-[100px] w-[100px] text-green-500" />
                </p>
                <Link to="." className="underline">
                  Start over
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="m-3 p-3 rounded-md border drop-shadow-sm sm:hidden ">
        <div className="h2 text-2xl font-bold mb-2">
          Schedule time with the Shopdeploy team to:{" "}
        </div>
        <div className="ml-6">
          <ul className="list-disc text-slate-900 text-lg leading-relaxed">
            <li>Get all your ecommerce questions answered</li>
            <li>See how we can help grow your business</li>
            <li>Do a live walkthrough of the platform</li>
            <li>Explore which pricing plan is best for you</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
